<template>
  <div class="page-wrapper">

    <div class="page p-material">
      <menu-item></menu-item>

      <div class="page-content">
      <div class="bg-orange pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2 header-content">
          <h2 v-html="$lang.p_3_left_header"></h2>
          <!-- <h4 v-html="$lang.p_3_left_header_ingress"></h4> -->
          <p v-html="$lang.p_3_left_header_ingress"></p>
        </div>

        <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-holder">
              <div class="icon p-3-header-i"></div>
            </div>
        </div>

      </div>
      <div class="p-section orange">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_3_sec_3_header"></h2>
            <p v-html="$lang.p_3_sec_3_txt"></p>
          </div>
        </div>
      </div>

      <div class="p-section beige">
        <div class="education-box pure-g">
          <div class="e-box pure-u-1-1 pure-u-md-1-3">
            <div class="icon-header pure-g">
              <div class="icon p-2-sheet-1 pure-u-1-3"></div>
              <h3 class="pure-u-2-3" v-html="$lang.p_3_edu_header_1"></h3>
            </div>
            <div class="e-txt" v-html="$lang.p_3_edu_para_1"></div>
          </div>
          <div class="e-box pure-u-1-1 pure-u-md-1-3">
            <div class="icon-header pure-g">
              <div class="icon p-2-sheet-2 pure-u-1-3"></div>
              <h3 class="pure-u-2-3" v-html="$lang.p_3_edu_header_2"></h3>
            </div>
            <div class="e-txt" v-html="$lang.p_3_edu_para_2"></div>
          </div>
          <div class="e-box pure-u-1-1 pure-u-md-1-3">
            <div class="icon-header pure-g">
              <div class="icon p-2-sheet-3 pure-u-1-3"></div>
              <h3 class="pure-u-2-3" v-html="$lang.p_3_edu_header_3"></h3>
            </div>
            <div class="e-txt" v-html="$lang.p_3_edu_para_3"></div>
          </div>
        </div>
      </div>

      <!-- Fact box -->
      <div class="fact-box pure-g">
        <div class="fact-part pure-u-1-1 pure-u-md-1-2">
          <h3 class="fact-header" v-html="$lang.p_3_fact_left_header"></h3>
          <div class="fact-body">
            <!-- Buttons -->
            <p class="fact-info" v-html="$lang.p_3_fact_left_info"></p>
          </div>
        </div>
        <div class="fact-part pure-u-1-1 pure-u-md-1-2">
          <!-- <div class="fact-header" v-html="$lang.fact_right_header"></div> -->
          <div class="fact-body">
            <!-- Buttons -->

            <!-- <div class="pdf-box pure-u-1-1 pure-u-md-1-2">
              <a v-for="(task, i) in tasks.items" :key="i"
                 class="pdf-link"
                 :href="('./static/pdf/' + tasks.link)"
                 target="_blank"
              >
                {{ $lang[task.name] }}
                <span class="icon-pdf"></span>
              </a>
            </div> -->
          <div class="pdf-box pure-u-1-1 pure-u-md-1-2">
              <a class="pdf-link" :href="'./static/documents/01.pdf'" download="studiematerial_01">
                <span v-html="$lang.doc_1"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/02.pdf'" download="studiematerial_02">
                <span v-html="$lang.doc_2"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/03.pdf'" download="studiematerial_03">
                <span v-html="$lang.doc_3"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/04.pdf'" download="studiematerial_04">
                <span v-html="$lang.doc_4"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/05.pdf'" download="studiematerial_05">
                <span v-html="$lang.doc_5"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/06.pdf'" download="studiematerial_06">
                <span v-html="$lang.doc_6"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/07.pdf'" download="studiematerial_07">
                <span v-html="$lang.doc_7"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/08.pdf'" download="studiematerial_08">
                <span v-html="$lang.doc_8"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/09.pdf'" download="studiematerial_09">
                <span v-html="$lang.doc_9"></span>
                <span class="icon-pdf"></span>
              </a>
              <a class="pdf-link" :href="'./static/documents/10.pdf'" download="studiematerial_10">
                <span v-html="$lang.doc_10"></span>
                <span class="icon-pdf"></span>
              </a>

            </div>

              </div>

        </div>
      </div>

        <!-- <div class="p-section">
          <div class="p-box pure-g">
            <div class="box-left pure-u-1-1 pure-u-md-1-2">
            </div>
            <div class="pure-u-1-1 pure-u-md-1-2"></div>
          </div>
        </div> -->

        <!-- <div class="a-box no-m-t ">
          <div class="pure-g">
            <div class="pdf-box pure-u-1-1 pure-u-md-1-2">
              <a v-for="(pdf, i) in pdfs.left" :key="i"
                 class="pdf-link"
                 :href="('./static/pdf/' + pdf.link)"
                 target="_blank"
              >
                {{ $lang[pdf.name] }}
                <span class="icon-pdf"></span>
              </a>
            </div>
            <div class="pdf-box pure-u-1-1 pure-u-md-1-2">
              <a v-for="(pdf, i) in pdfs.right" :key="i"
                 class="pdf-link"
                 :href="('./static/pdf/' + pdf.link)"
                 target="_blank"
              >
                {{ $lang[pdf.name] }}
                <span class="icon-pdf"></span>
              </a>
            </div>
          </div>
        </div> -->

      </div>
    </div>

    <!-- To next part -->
    <div class="to-next-box resourses">
      <h4 v-html="$lang.done_part_material"></h4>
      <div class="btn-holder">
        <div class="btn white arrow" v-touch:tap="toPartOne">
          <p>{{ $lang.to_part_small }} 1</p>
        </div>
        <div class="btn white arrow" v-touch:tap="toPartTwo">
          <p>{{ $lang.to_part_small }} 2</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../../components/menu'
import PDFS from '../../../assets/data/recourse_pdf.json'
import Tasks from '../../../assets/data/tasks.json'
export default {
  name: 'material',
  data () {
    return {
      overlay: false,
      pdfs: PDFS,
      tasks: Tasks
    }
  },
  beforeMount () {
    this.$root.shared.currentPage = 'Material'
  },
  mounted () {
    this.util.addBodyClass('recourse-bg')
  },
  methods: {
    toPartOne () {
      return this.onToPartOne()
    },
    onToPartOne () {
      this.$router.push({'name': 'Improvement'})
    },
    toPartTwo () {
      return this.onToPartTwo()
    },
    onToPartTwo () {
      this.$router.push({'name': 'Dementia'})
    }
  },
  beforeDestroy () {
    this.util.removeBodyClass('recourse-bg')
  },
  components: {
    'menu-item': Menu
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/material/index.vue